export default "__VITE_ASSET__BsIvvMPi__"